export default theme => ({
  viewContainer: {
    width: '100%',
    height: 'calc(100% - 40px)',
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.primary.white
  },
  emptyView: {
    width: 350,
    margin: '0 auto',
    padding: '80px 0',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16
  },
  emptyIcon: {
    width: 80,
    display: 'inline-block'
  },
  emptyBigIcon: {
    width: 250,
    display: 'inline-block'
  },
  emptyImage: {
    '& img': {
      height: 100
    }
  },
  emptyButton: {
    textAlign: 'center'
  },
  actionsContainer: {
    display: 'none',
    position: 'absolute',
    right: 1,
    paddingLeft: 30,
    paddingRight: 20,
    zIndex: 1,
    background: `linear-gradient(to right, ${theme.colors.transparent}, ${theme.colors.actionMinor[50]} 13%, ${theme.colors.actionMinor[50]} 26%)`
  },
  hideActions: {
    display: 'none !important'
  },
  customScroll: {
    right: 12
  },
  nativeScroll: {
    right: 18
  },
  actionsContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  actionsIcon: {
    margin: '0 5px',
    cursor: 'pointer',
    '& svg path': {
      fill: theme.colors.actionMinor[500]
    },
    '&:hover svg path': {
      fill: theme.colors.grey[700]
    }
  },
  disabled: {
    pointerEvents: 'none'
  }
});